import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { ExchangeCountState } from "@redotech/redo-return-ui/flows/return-flow/condition-types/exchange-count";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const ExchangeCountDetails = memo(function ExchangeCountDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<ExchangeCountState>) {
  return (
    <RedoTextInput
      inputTypeHint="number"
      label="# exchanges (customers with fewer previous exchanges will pass)"
      min={1}
      onBlur={() => setState((+state).toFixed(0))}
      setValue={(e) => setState(e)}
      size="sm"
      state={disabled ? "disabled" : "default"}
      value={state}
    />
  );
});
